import React from 'react';
import { cn } from '@/lib/utils';
import { HoverCard, HoverCardTrigger, HoverCardContent } from '@/components/ui/hover-card';

const stripMarkdown = (text: string): string => {
  return text
    .replace(/#{1,6}\s+/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/^\s*[-*+]\s+/gm, '• ')
    .replace(/\n{2,}/g, ' ')
    .replace(/\n/g, ' ')
    .trim();
};

interface LeadDescriptionSnippetProps {
  summary?: string | null;
  fallback?: string | null;
  lines?: 2 | 4;
  className?: string;
}

const LeadDescriptionSnippet: React.FC<LeadDescriptionSnippetProps> = ({
  summary,
  fallback,
  lines = 4,
  className,
}) => {
  const raw = summary || fallback;
  if (!raw) return null;

  const cleaned = stripMarkdown(raw);
  if (!cleaned) return null;

  return (
    <HoverCard openDelay={300}>
      <HoverCardTrigger asChild>
        <p className={cn(
          'text-xs text-muted-foreground/70 cursor-help',
          lines === 4 ? 'line-clamp-4' : 'line-clamp-2',
          className
        )}>
          {cleaned}
        </p>
      </HoverCardTrigger>
      <HoverCardContent className="w-80 max-h-60 overflow-y-auto" side="top" align="start">
        <p className="text-sm leading-relaxed text-popover-foreground">{cleaned}</p>
      </HoverCardContent>
    </HoverCard>
  );
};

export default LeadDescriptionSnippet;
